import { Injectable } from '@angular/core'

import { Observable } from 'rxjs/Observable'

import { LectureApiBase } from './lecture-api'
import { Reply, Event } from '../models'

@Injectable()
export class ReplyApi {
  private apiPath(eventId: number) {
    return `events/${eventId}/replies`
  }

  constructor(
    private api: LectureApiBase,
  ) { }

  directPost(eventId: number, payload: any): Observable<Event> {
    return this.api.postWithObject(Event, this.apiPath(eventId),
      {
        reply: payload
      }
    )
  }

  delete(eventId:number, id: number): Observable<Event> {
    return this.api.delete(`${this.apiPath(eventId)}/${id}`).map((r) => new Event(r))
  }
}



// WEBPACK FOOTER //
// ./src/apis/reply.ts